package com.essntl.features.tag.ui.addedittag

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.tag.domain.model.TagModel

data class AddEditTagState(
    val tag: MutableState<TagModel> = mutableStateOf(TagModel.empty),
    val getTag: State<TagModel> = State(),
    val addEditTag: State<TagModel> = State(),
    val deleteTag: State<Unit> = State(),
    val isEditEnabled: Boolean = false,
)